import { Head } from '@inertiajs/react';
import type { ArcadeMachinesIndex } from '@/types';
import { ArcadeMachine } from './components/arcade-machine';

export default function Index({ games }: ArcadeMachinesIndex) {
  return (
    <>
      <Head title="Arcade Machine | Platanus Hack 26">
        <meta
          name="description"
          content="Play arcade games on the Platanus Hack 26 arcade machine"
        />
      </Head>
      <ArcadeMachine games={games} />
    </>
  );
}
